// Persist per-user scan settings in localStorage.
const DEFAULTS = {
  scannerId: '',
  source: 'Feeder',
  colorMode: 'BlackWhite',
  dpi: 300,
  brightness: 0,
  contrast: 0,
  skipBlankPages: true,
  compressScans: true,
  useManufacturerDialog: false,
};

const keyFor = (userId) => `modesk.scanSettings.${userId || 'default'}`;

export function getScanSettings(userId) {
  try {
    const raw = localStorage.getItem(keyFor(userId));
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch { return { ...DEFAULTS }; }
}

export function saveScanSettings(userId, settings) {
  try {
    localStorage.setItem(keyFor(userId), JSON.stringify({ ...DEFAULTS, ...settings }));
  } catch (e) { console.error("Failed to save scan settings:", e); }
}

export function getScanDefaults() { return { ...DEFAULTS }; }
